import { render, staticRenderFns } from "./AboutSlider.vue?vue&type=template&id=e8a50af6"
import script from "./AboutSlider.vue?vue&type=script&lang=js"
export * from "./AboutSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports